import { useCallback } from "react";
import { useSearchParams } from "react-router-dom";

/**
 * Keeps a list page's status tab in the URL (?status=...), so the sidebar
 * submenus, page tabs, refresh and shared links all show the same filter.
 * Drop-in replacement for useState<string>("").
 */
const useStatusParam = (): [string, (value: string) => void] => {
  const [params, setParams] = useSearchParams();
  const status = params.get("status") ?? "";

  const setStatus = useCallback(
    (value: string) =>
      setParams(
        (prev) => {
          const next = new URLSearchParams(prev);
          if (value) next.set("status", value);
          else next.delete("status");
          return next;
        },
        { replace: true }
      ),
    [setParams]
  );

  return [status, setStatus];
};

export default useStatusParam;
